module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'documents',
        'document',
        'document',
    ],
    model: {
        documentData: {}
    },

    methods: {
        prepare: function(storage, isServer){
            const documentData = (storage.request || {}).documentData
            if(documentData){
                this.model.documentData = documentData
            }
        }
    }
}